import { useEffect, useState, useRef } from 'react';
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Button, Form, Row, Col, Select, DatePicker, Space, message } from 'antd';
import { downloadTxt } from '../../../../apis/SUAIncapacidadesApi';
import { getList as getRegistrosPatronales } from '../../../../apis/RegistroPatronalApi';
import dayjs from 'dayjs';

const { Option } = Select;

const routes = [{
  href: '',
  title: <>
    <HomeOutlined />
    <span>Inicio</span>
  </>,
}, {
  href: '',
  title: (
    <>
      <UnorderedListOutlined />
      <span>Catálogos</span>
    </>
  ),
}, {
  href: '',
  title: (
    <>
      <UnorderedListOutlined />
      <span>SUA Incapacidades</span>
    </>
  ),
}];

const SUAIncapacidades = () => {
  const [form] = Form.useForm();
  const [ID, setID] = useState(0);
  const [loading, setLoading] = useState(true);
  const [registrosPatronales, setRegistrosPatronales] = useState([]);
  const [initialValues, setInitialValues] = useState(null);
  const [modified, setModified] = useState(false);

  // Get first and last day of current month
  const getFirstAndLastDayOfMonth = () => {
    const firstDay = dayjs().startOf('month');
    const lastDay = dayjs().endOf('month');
    return { firstDay, lastDay };
  };

  const handleSave = async () => {
    try {
      await form.validateFields();
      
      const values = form.getFieldsValue();
      
      const fecha_inicial = values.fecha_inicial.format('YYYY-MM-DDTHH:mm:ss');
      const fecha_final = values.fecha_final.format('YYYY-MM-DDTHH:mm:ss');
      
      await downloadTxt(values.registro_patronal_id, fecha_inicial, fecha_final);
    } catch (error) {
      console.error('Error:', error);
      message.error('Por favor, verifica los campos del formulario');
    }
  };

  const resetForm = () => {
    const { firstDay, lastDay } = getFirstAndLastDayOfMonth();
    form.resetFields();
    form.setFieldsValue({
      activo: true,
      fecha_inicial: firstDay,
      fecha_final: lastDay
    });
    setID(0);
  };

  const getListRegistrosPatronales = async () => {
    const response = await getRegistrosPatronales();
    if (response.ok) {
      let items = response.payload;
      setRegistrosPatronales(items);
    }
  };

  const effectRan = useRef(false);
  useEffect(() => {
    if (!effectRan.current) {
      (async () => {
        await getListRegistrosPatronales();
        
        // Set default date values to first and last day of current month
        const { firstDay, lastDay } = getFirstAndLastDayOfMonth();
        
        // No establecemos las fechas como parte del initialValues
        setInitialValues({
          activo: true
        });
        
        // En su lugar, establecemos los valores después de que el formulario se ha montado
        setTimeout(() => {
          form.setFieldsValue({
            fecha_inicial: firstDay,
            fecha_final: lastDay
          });
        }, 0);
        
        setLoading(false);
      })();
    }
    return () => effectRan.current = true;
  }, [form]);

  return <PageApp
    routes={routes}
    title={'SUA Incapacidades'}
    cardTitle='Formulario de incapacidades'>
    {
      loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {initialValues && (
            <Form
              layout="vertical"
              form={form}
              requiredMark
              autoComplete="off"
              initialValues={initialValues}
              onFinish={handleSave}>
              <Row gutter={16}>
                <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                  <Form.Item
                    name="registro_patronal_id"
                    label="Registro Patronal"
                    rules={[
                      {
                        required: true,
                        message: 'Selecciona un registro patronal',
                      },
                    ]}
                  >
                    <Select placeholder="Por favor selecciona una opción">
                      {
                        registrosPatronales.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                      }
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                  <Form.Item
                    name="fecha_inicial"
                    label="Fecha Inicial"
                  >
                    <DatePicker 
                      placeholder="DD/MM/YYYY" 
                      style={{ width: '100%' }} 
                      format={'DD/MM/YYYY'} 
                    />
                  </Form.Item>
                </Col>
                <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                  <Form.Item
                    name="fecha_final"
                    label="Fecha Final"
                  >
                    <DatePicker 
                      placeholder="DD/MM/YYYY" 
                      style={{ width: '100%' }} 
                      format={'DD/MM/YYYY'} 
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Space>
                    <Button type="primary" htmlType="submit">
                      Descargar
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form>
          )}
        </>
      )
    }
  </PageApp>
};

export default SUAIncapacidades;